import { useEffect, useRef, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  BookOpen, Calculator, CalendarDays, ChevronDown, CloudSun, Gavel, Heart, ListChecks, Map,
  MessagesSquare, Moon, PackageCheck, ScrollText, Sparkles, Sprout, Stethoscope, Store,
  TrendingUp, Truck, Users,
} from "lucide-react";

const link = "rounded-lg px-3 py-2 text-sm font-semibold text-primary hover:bg-muted";

/** Üye girişinden sonra menünün taşmaması için ana başlıklar + gruplu açılır menü. */
export const DesktopNavMenu = ({ user, isVet }) => {
  const [open, setOpen] = useState(false);
  const box = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (box.current && !box.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const groups = [
    ["Pazar", [
      ["/mezat", Gavel, "Ciftora Mezat", "menu-auctions"],
      ["/magazalar", Store, "Mağazalar", "menu-stores"],
      ["/nakliye", Truck, "Nakliye Ağı", "menu-transport"],
      ["/kasap-bul", PackageCheck, "Kasap & Kesimhane", "menu-butcher"],
      ["/degerleme", Calculator, "Değerleme", "menu-valuation"],
    ]],
    ["Piyasa & Bilgi", [
      ["/fiyat-haritasi", Map, "Fiyat Haritası", "menu-price-map"],
      ["/mevzuat", ScrollText, "Mevzuat ve Destekler", "menu-regulations"],
      ["/fuarlar", CalendarDays, "Fuar Takvimi", "menu-fairs"],
      ["/kurban", Moon, "Kurban Market", "menu-sacrifice"],
      ["/hava", CloudSun, "Ciftora Hava", "menu-weather"],
      ["/forum", MessagesSquare, "Forum", "menu-forum"],
      ["/kilavuz", BookOpen, "Kullanım Kılavuzu", "menu-guide"],
    ]],
    ["Çiftlik & Hizmet", [
      ["/ciftora-ai", Sparkles, "Ciftora AI", "menu-ai"],
      ["/veterinerler", Stethoscope, "Veteriner Hekim Bul", "menu-vet-directory"],
      ["/kooperatif", Users, "Kooperatif & Birlik", "menu-coop"],
      ["/gorevlerim", ListChecks, "Görevlerim", "menu-tasks"],
      [isVet ? "/veteriner" : "/veteriner/profil", Stethoscope,
        isVet ? "Veteriner Panelim" : "Veteriner Ol", "menu-vet-panel"],
    ]],
    ["Hesabım", [
      ["/panel/favoriler", Heart, "Favorilerim", "menu-favorites"],
      ["/panel/mesajlar", MessagesSquare, "Mesajlarım", "menu-messages"],
      ["/panel/siparislerim", PackageCheck, "Siparişlerim", "menu-orders"],
    ]],
  ];

  return (
    <>
      <NavLink to="/ilanlar" data-testid="nav-listings" className={link}>İlanlar</NavLink>
      <NavLink to="/panel" data-testid="nav-dashboard" className={link}>Panelim</NavLink>
      <NavLink to="/ciftligim" data-testid="nav-farm"
        className={`inline-flex items-center gap-1.5 ${link}`}>
        <Sprout className="h-4 w-4" /> Çiftliğim
      </NavLink>
      <NavLink to="/fiyatlar" data-testid="nav-market-prices"
        className={`inline-flex items-center gap-1.5 ${link}`}>
        <TrendingUp className="h-4 w-4" /> Piyasa
      </NavLink>

      <div className="relative" ref={box}>
        <button
          data-testid="nav-more-btn"
          onClick={() => setOpen((o) => !o)}
          aria-expanded={open}
          className={`inline-flex items-center gap-1.5 ${link}`}
        >
          Tüm Bölümler
          <ChevronDown className={`h-4 w-4 transition-transform ${open ? "rotate-180" : ""}`} />
        </button>
        {open && (
          <div
            data-testid="nav-more-menu"
            className="absolute right-0 top-full z-50 mt-2 grid w-[620px] grid-cols-2 gap-x-6 gap-y-1 rounded-xl border border-border bg-background p-4 shadow-xl"
          >
            {groups.map(([title, items]) => (
              <div key={title}>
                <p className="px-2 pb-1 pt-2 text-[11px] font-bold uppercase tracking-wider text-muted-foreground">
                  {title}
                </p>
                {items.map(([to, Icon, label, testid]) => (
                  <Link
                    key={testid}
                    to={to}
                    data-testid={testid}
                    onClick={() => setOpen(false)}
                    className="flex items-center gap-2.5 rounded-lg px-2 py-2 text-sm font-semibold text-primary hover:bg-muted"
                  >
                    <Icon className="h-4 w-4 shrink-0 text-secondary" /> {label}
                  </Link>
                ))}
              </div>
            ))}
          </div>
        )}
      </div>
    </>
  );
};
